import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, PhoneCall, Trophy, Images, Columns2, Sparkles, CalendarCheck } from "lucide-react";
import { api } from "../lib/api";

const CARDS = [
  { key: "new_leads", label: "New Leads", icon: Sparkles, accent: true },
  { key: "total_leads", label: "Total Estimate Requests", icon: Inbox },
  { key: "contacted", label: "Contacted Leads", icon: PhoneCall },
  { key: "scheduled", label: "Estimate Scheduled", icon: CalendarCheck },
  { key: "won", label: "Won Projects", icon: Trophy },
  { key: "gallery_photos", label: "Gallery Photos", icon: Images },
  { key: "before_after", label: "Before & After Projects", icon: Columns2 },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="portal-dashboard">
      <h1 className="font-heading font-extrabold text-[#0B1B3D] text-2xl md:text-3xl mb-8">NOYOLA CONSTRUCTION LLC</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={`stat-${c.key}`} className={`p-6 border ${c.accent ? "bg-[#005AE0] border-[#005AE0] text-white" : "bg-white border-slate-200"}`}>
            <c.icon className={`w-6 h-6 mb-4 ${c.accent ? "text-white" : "text-[#005AE0]"}`} />
            <p className={`font-heading font-extrabold text-3xl ${c.accent ? "text-white" : "text-[#0B1B3D]"}`}>{stats ? stats[c.key] : "—"}</p>
            <p className={`text-sm mt-1 ${c.accent ? "text-blue-100" : "text-slate-500"}`}>{c.label}</p>
          </div>
        ))}
      </div>
      <div className="bg-white border border-slate-200">
        <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
          <h2 className="font-heading font-bold text-[#0B1B3D]">Recent Estimate Requests</h2>
          <Link to="/portal/leads" className="text-sm text-[#005AE0] font-semibold" data-testid="dashboard-all-leads-link">View all</Link>
        </div>
        {stats?.recent_leads?.length ? stats.recent_leads.map((l) => (
          <Link key={l.id} to={`/portal/leads/${l.id}`} className="flex items-center justify-between px-6 py-4 border-b border-slate-100 hover:bg-slate-50 transition-colors">
            <div>
              <p className="font-heading font-bold text-[#0B1B3D] text-sm">{l.name}</p>
              <p className="text-xs text-slate-500">{l.service} • {new Date(l.created_at).toLocaleDateString()}</p>
            </div>
            <span className="text-xs font-heading font-bold uppercase tracking-wide px-3 py-1 bg-slate-100 text-slate-600">{l.status}</span>
          </Link>
        )) : <p className="px-6 py-10 text-slate-400 text-sm">No estimate requests yet.</p>}
      </div>
    </div>
  );
}
